export { default } from "./ErrorBoundary"
